import { getChargeDetails, inquiry, UserCharge } from "../../services/services";
import { useQuery } from "@tanstack/react-query";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { simCardFormatter } from "../../formatters/simcardFormatter";
import PersianDate from "../../components/PersianDate/PersianDate";
import { useState } from "react";

const HistoryCharge = ({ id, isMobile }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(9);

  const { data } = useQuery({
    queryKey: ["UserCharge", id, pageNumber, pageSize],
    queryFn: () =>
      UserCharge({
        userId: id,
        pageNumber,
        pageSize,
      }),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
    enabled: !!id,
  });

  const chargeDetails = data?.items ?? [];
  const totalCount = data?.totalCount ?? 0;

  const columns = [
    {
      field: "creationTime",
      header: "تاریخ",
      body: (rowData) => <PersianDate date={rowData.creationTime} />,
      sortable: true,
      style: { textAlign: "right" },
    },
    {
      field: "targetPhoneNumber",
      header: " شماره موبایل ",
      style: { textAlign: "right" },
    },
    {
      field: "operator",
      header: " اوپراتور ",
      style: { textAlign: "right" },
    },
  ];

  const itemTemplate = (item) => (
    <div
      key={item.ID}
      className="rounded shadow-sm mb-3 p-3"
      style={{ backgroundColor: "#f9f9f9", border: "1px solid #eee" }}
    >
      <div className="mb-1">
        <strong>شناسه تراکنش:</strong> {item.id}
      </div>
      <div className="mb-1">
        <strong>کدشارژ:</strong> {item.Code}
      </div>
      <div className="mb-1">
        <strong>نوع سیمکارت:</strong> {simCardFormatter(item.Type)}
      </div>
      <div className="mb-1">
        <strong>تاریخ:</strong> <PersianDate date={item.Date} />
      </div>

      <div className="mb-1 d-flex justify-content-center mt-4">
        {/* <button
          onClick={() => inquiry({ TransactionId: item.TransactionID })}
          style={{
            color: "#ffff",
            background: "#13742b",
            border: "0px",
            width: "68px",
            borderRadius: "8px",
            padding: "2px",
          }}
        >
          استعلام
        </button> */}
      </div>
    </div>
  );

  return (
    <div className="card mt-4" style={isMobile ? {} : { height: "650px" }}>
      <h5> تاریخچه دریافت شارژ </h5>
      {chargeDetails?.length > 0 ? (
        <div className="background-dataTable">
          <ResponsiveDataList
            data={chargeDetails}
            columns={columns}
            itemTemplate={itemTemplate}
            dataViewHeader={<></>}
            className="farsi-monospace-digit"
            rows={pageSize}
            rowsPerPageOptions={[9, 20, 50]}
            pageNumber={pageNumber}
            totalCount={totalCount}
            onPageChange={({ pageNumber: p, pageSize: s }) => {
              setPageNumber(p);
              setPageSize(s);
            }}
          />
        </div>
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "rgb(100, 100, 100)",
          }}
        >
          <h5>موردی یافت نشد !</h5>
        </div>
      )}
    </div>
  );
};

export default HistoryCharge;
